// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1m5v9","approved":"Status_approved__2PDIE","rejected":"Status_rejected__1FCAn","expired":"Status_expired__3c2Y3","label":"Status_label__iZR1U"};